var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'dark-mode': _vm.userDataStore.darkMode},attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in","name":"fade"}},[_c('router-view')],1),_c('badge-catcher')],1)}
var staticRenderFns = []

export { render, staticRenderFns }